@if (!withPopup) {
  <kendo-loader [type]="'infinite-spinner'"
    [size]="size"
  [themeColor]="themeColor"></kendo-loader>
}

@if (withPopup) {
  <div class="popup-overlay"></div>
  <kendo-window [resizable]="false" title="Loading"
    class="LoadingWindow">
    <div class="row">
      <div class="col-12">
        <kendo-loader [type]="'infinite-spinner'"
          [size]="size"
        [themeColor]="themeColor"></kendo-loader>
      </div>
    </div>
    <div class="row">
      <div class="col-12 messageContainer">
        @if (!_savingMode) {
          <div class="messageLoaderTitle"
          >Fetching the latest data</div>
        }
        @if (_savingMode) {
          <div class="messageLoaderTitle"
          >Saving</div>
        }
        <div class="border-separator"></div>
        {{_loadingMessage}}
      </div>
    </div>
  </kendo-window>
}
